import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/#webpage",
   "url": "https://www.futurefamilyai.com/",
   "name": "Pregnancy Monitoring App, Doctor-Connected | FutureFamilyAI",
   "description": "Home BP readings, smartwatch trends and symptoms in one calm color status your care team can review between visits. Free pilot through Dec 31, 2026.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Can a smartwatch measure blood pressure during pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Not for FutureFamilyAI. Apple Watch does not measure blood pressure, and Apple's hypertension notifications are not intended for use in pregnancy. Samsung Galaxy Watch estimates blood pressure only after cuff calibration. FutureFamilyAI uses a validated upper-arm cuff as the only blood pressure source; your watch adds heart-rate, PRV, sleep and activity trends."
     }
    },
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI safe to use during pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. It is a non-invasive wellness app that reads data from your cuff and watch and asks simple symptom questions. It does not give medical treatment, and it encourages you to follow your own clinician's instructions."
     }
    },
    {
     "@type": "Question",
     "name": "Who reviews my alerts?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Orange and Red statuses are reviewed by a care team working with your clinician's instructions — never by an algorithm alone. Reviews happen during care-team hours; the app is not monitored in real time and is not an emergency service."
     }
    },
    {
     "@type": "Question",
     "name": "Can surrogates use FutureFamilyAI?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Gestational surrogates can enroll directly or through a participating agency. The surrogate controls sharing, and intended parents see only what she chooses to share."
     }
    },
    {
     "@type": "Question",
     "name": "Is my health information private?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Nothing is shared by default. You turn on sharing one person at a time — your physician, partner, coordinator or intended parents — and you can turn it off, export or delete your data whenever you choose."
     }
    },
    {
     "@type": "Question",
     "name": "Who is behind FutureFamilyAI?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "FutureFamilyAI is a product of HelixFoundry, Inc., and is used by Surrogacy4All to support its surrogates. Its clinical content is authored by Dr. Kulsoom Baloch, MBBS, MPH, and Dr. Pooja Patel, MD, and reviewed by Dr. Rashmi Gulati, MD, of Patients Medical."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  },
  {
   "@type": "MobileApplication",
   "name": "FutureFamilyAI",
   "operatingSystem": "iOS, Android",
   "applicationCategory": "HealthApplication",
   "offers": [
    {
     "@type": "Offer",
     "price": "0",
     "priceCurrency": "USD",
     "description": "Free pilot through December 31, 2026",
     "priceValidUntil": "2026-12-31"
    },
    {
     "@type": "Offer",
     "price": "39.99",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, monthly (after pilot)"
    },
    {
     "@type": "Offer",
     "price": "399",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, annual (after pilot)"
    }
   ],
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   }
  }
 ]
}`;

const css = `
/* Layout: one 1160px column; full-bleed tinted bands carry the flyer's journey colors; content cards only where they are objects (phone, pricing, status tiles). */
.ffh-home{
  color-scheme: light;
  --blue:#1F6FB2; --blue-ink:#0E3F6B; --blue-deep:#0B2E52; --sky:#EAF3FB; --sky-2:#D7E8F7;
  --orange:#E8842C; --orange-ink:#B85E12; --orange-hover:#D27220;
  --ink:#16263A; --muted:#55657A; --line:#D9E3EE; --paper:#FFFFFF; --wash:#F5F8FC;
  --green:#2E9E4F; --yellow:#E8B923; --amber:#E8842C; --red:#D64545;
  --plan:#1F6FB2; --preg:#7A4FCF; --post:#D2477E; --after:#2E9E4F;
  --plan-bg:#EAF3FB; --preg-bg:#F2ECFC; --post-bg:#FCEBF2; --after-bg:#E9F6EE;
  --sans:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
  --r-sm:8px; --r-md:14px; --r-lg:22px;
  --fs-xs:.8125rem; --fs-sm:.9375rem; --fs-md:1.0625rem; --fs-lg:1.25rem; --fs-xl:clamp(1.5rem,1.1rem + 1.4vw,2rem); --fs-2xl:clamp(2rem,1.3rem + 2.8vw,3.25rem);
}
.ffh-home,.ffh-home *{box-sizing:border-box}
html{scroll-behavior:smooth}
@media (prefers-reduced-motion:reduce){html{scroll-behavior:auto}.ffh-home,.ffh-home *{transition:none!important;animation:none!important}}
.ffh-home{margin:0;background:var(--paper);color:var(--ink);font-family:var(--sans);font-size:var(--fs-md);line-height:1.6;-webkit-font-smoothing:antialiased}
.ffh-home img{max-width:100%}
.ffh-home a{color:var(--blue)}
.ffh-home a:focus-visible,.ffh-home button:focus-visible,.ffh-home summary:focus-visible,.ffh-home input:focus-visible,.ffh-home select:focus-visible{outline:3px solid var(--orange);outline-offset:2px;border-radius:4px}
.ffh-home h1,.ffh-home h2,.ffh-home h3{color:var(--blue-deep);line-height:1.15;text-wrap:balance;margin:0}
.ffh-home h1{font-size:var(--fs-2xl);font-weight:800;letter-spacing:-.02em}
.ffh-home h2{font-size:var(--fs-xl);font-weight:800;letter-spacing:-.01em}
.ffh-home h3{font-size:var(--fs-lg);font-weight:700}
.ffh-home p{margin:0}
.ffh-home .ffh-wrap{max-width:1160px;margin:0 auto;padding-left:max(20px,env(safe-area-inset-left,0px));padding-right:max(20px,env(safe-area-inset-right,0px))}
.ffh-home .ffh-band{padding-block:clamp(48px,6vw,88px)}
.ffh-home .ffh-band.ffh-wash{background:var(--wash)}
.ffh-home .ffh-band.ffh-sky{background:linear-gradient(180deg,var(--sky) 0%,var(--paper) 100%)}
.ffh-home .ffh-band.ffh-deep{background:var(--blue-deep);color:#E6EEF7}
.ffh-home .ffh-band.ffh-deep h2,.ffh-home .ffh-band.ffh-deep h3{color:#fff}
.ffh-home .ffh-eyebrow{font-size:var(--fs-xs);font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--blue)}
.ffh-home .ffh-band.ffh-deep .ffh-eyebrow{color:#9FC6EA}
.ffh-home .ffh-lead{font-size:clamp(1.0625rem,1rem + .4vw,1.25rem);color:var(--muted);max-width:62ch}
.ffh-home .ffh-stack{display:grid;gap:14px}
.ffh-home .ffh-sec-head{display:grid;gap:10px;margin-bottom:32px;max-width:720px}

/* header */
.ffh-home::before{content:"";position:fixed;inset:0 0 auto;height:env(safe-area-inset-top,0px);z-index:10;background:rgba(255,255,255,.96)}
.ffh-home .ffh-site-head{position:sticky;top:env(safe-area-inset-top,0px);z-index:9;background:rgba(255,255,255,.96);backdrop-filter:saturate(1.4) blur(8px);border-bottom:1px solid var(--line)}
.ffh-home .ffh-site-head .ffh-wrap{display:flex;align-items:center;gap:20px;min-height:68px}
.ffh-home .ffh-brand{display:flex;align-items:center;gap:10px;text-decoration:none;color:var(--blue-ink);flex:0 0 auto}
.ffh-home .ffh-brand svg{width:38px;height:38px}
.ffh-home .ffh-brand b{font-size:1.25rem;font-weight:800;letter-spacing:-.01em;color:var(--blue-ink)}
.ffh-home .ffh-brand b span{color:var(--blue)}
.ffh-home .ffh-brand small{display:block;font-size:.625rem;letter-spacing:.14em;text-transform:uppercase;color:var(--muted);font-weight:700;margin-top:-2px}
.ffh-home .ffh-nav{display:flex;gap:2px;margin-left:auto;flex-wrap:nowrap}
.ffh-home .ffh-nav a{color:var(--ink);text-decoration:none;font-size:var(--fs-sm);font-weight:600;padding:8px 9px;border-radius:var(--r-sm);white-space:nowrap}
.ffh-home .ffh-nav a:hover{background:var(--sky)}
.ffh-home .ffh-head-cta{display:flex;gap:14px;align-items:center}
.ffh-home .ffh-login{font-weight:700;font-size:var(--fs-sm);text-decoration:none;color:var(--blue-ink);white-space:nowrap}
@media (max-width:1440px){.ffh-home .ffh-nav a:nth-child(4){display:none}}
@media (max-width:1100px){.ffh-home .ffh-nav{display:none}.ffh-home .ffh-head-cta{margin-left:auto}.ffh-home .ffh-head-cta .ffh-btn.ffh-ghost{display:none}}
@media (max-width:560px){.ffh-home .ffh-head-cta{display:none}.ffh-home .ffh-brand small{display:none}}

/* buttons */
.ffh-home .ffh-btn{white-space:nowrap;display:inline-flex;align-items:center;justify-content:center;gap:8px;min-height:48px;padding:0 22px;border-radius:999px;font-weight:700;font-size:var(--fs-sm);text-decoration:none;border:2px solid transparent;cursor:pointer;transition:background .15s,transform .15s}
.ffh-home .ffh-btn.ffh-primary{background:var(--orange);color:#fff}
.ffh-home .ffh-btn.ffh-primary:hover{background:var(--orange-hover);transform:translateY(-1px)}
.ffh-home .ffh-btn.ffh-ghost{background:transparent;color:var(--blue-ink);border-color:var(--blue)}
.ffh-home .ffh-btn.ffh-ghost:hover{background:var(--sky)}
.ffh-home .ffh-btn.ffh-light{background:#fff;color:var(--blue-ink)}
.ffh-home .ffh-btn.ffh-sm{min-height:40px;padding:0 16px}
.ffh-home .ffh-btn svg{width:18px;height:18px;flex:0 0 auto}
.ffh-home .ffh-cta-row{display:flex;gap:12px;flex-wrap:wrap;align-items:center}
.ffh-home .ffh-micro{font-size:var(--fs-xs);color:var(--muted)}
.ffh-home .ffh-band.ffh-deep .ffh-micro{color:#B9CCE0}

/* fast facts (AI smart summary) */
.ffh-home .ffh-facts{border:1px solid var(--sky-2);background:var(--paper);border-radius:var(--r-md);padding:18px 20px;display:grid;gap:12px}
.ffh-home .ffh-facts-title{display:flex;align-items:center;gap:8px;font-size:var(--fs-xs);font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:var(--blue)}
.ffh-home .ffh-facts .ffh-q{font-size:var(--fs-sm);color:var(--ink)}
.ffh-home .ffh-facts details summary{cursor:pointer;font-size:var(--fs-xs);font-weight:700;color:var(--blue);margin-bottom:4px}
.ffh-home .ffh-facts details[open] summary{margin-bottom:12px}
.ffh-home .ffh-facts dl{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:12px 24px;margin:0}
.ffh-home .ffh-facts dt{font-size:var(--fs-xs);font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.06em}
.ffh-home .ffh-facts dd{margin:2px 0 0;font-size:var(--fs-sm);color:var(--ink)}

/* hero */
.ffh-home .ffh-hero{background:radial-gradient(1200px 480px at 85% -10%,var(--sky-2) 0%,rgba(215,232,247,0) 60%),linear-gradient(180deg,var(--sky) 0%,#fff 92%);padding-block:clamp(28px,4vw,56px) clamp(48px,6vw,80px)}
.ffh-home .ffh-hero-grid{display:grid;grid-template-columns:minmax(0,1.15fr) minmax(0,.85fr);gap:clamp(28px,4vw,64px);align-items:center;margin-top:28px}
.ffh-home .ffh-hero-copy{display:grid;gap:20px;min-width:0}
.ffh-home .ffh-hero h1 em{font-style:normal;color:var(--blue)}
.ffh-home .ffh-pilot-badge{display:inline-flex;align-items:center;gap:10px;align-self:start;justify-self:start;background:#FFF3E6;color:var(--orange-ink);border:1px solid #F6CFA5;border-radius:999px;padding:6px 14px 6px 8px;font-size:var(--fs-sm);font-weight:700}
.ffh-home .ffh-pilot-badge i{display:inline-block;width:10px;height:10px;border-radius:50%;background:var(--orange);box-shadow:0 0 0 4px #FBE0C4}
.ffh-home .ffh-safety{display:flex;gap:10px;align-items:flex-start;font-size:var(--fs-xs);color:var(--muted);max-width:60ch}
.ffh-home .ffh-safety svg{flex:0 0 18px;width:18px;height:18px;color:var(--blue);margin-top:1px}
@media (max-width:900px){.ffh-home .ffh-hero-grid{grid-template-columns:1fr}}

/* phone mockup */
.ffh-home .ffh-device{position:relative;justify-self:center;width:min(320px,100%)}
.ffh-home .ffh-phone{background:#0E1C2C;border-radius:42px;padding:12px;box-shadow:0 30px 60px -20px rgba(11,46,82,.45)}
.ffh-home .ffh-screen{background:#F7FAFD;border-radius:32px;padding:22px 18px 18px;display:grid;gap:12px}
.ffh-home .ffh-screen .ffh-top{display:flex;justify-content:space-between;font-size:.75rem;color:var(--muted);font-weight:600}
.ffh-home .ffh-screen h4{margin:0;font-size:1.05rem;color:var(--blue-deep)}
.ffh-home .ffh-status{border-radius:18px;padding:16px;display:grid;gap:6px;background:linear-gradient(135deg,#E5F5EA,#F3FBF5);border:1px solid #BFE3CA}
.ffh-home .ffh-status .ffh-pill{display:inline-flex;align-items:center;gap:8px;font-weight:800;color:#1F7A3B;font-size:1.05rem}
.ffh-home .ffh-status .ffh-pill i{width:12px;height:12px;border-radius:50%;background:var(--green);box-shadow:0 0 0 5px #CDEBD6}
.ffh-home .ffh-status p{font-size:.8rem;color:#2C4A37}
.ffh-home .ffh-tile{background:#fff;border:1px solid var(--line);border-radius:14px;padding:10px 12px;display:grid;grid-template-columns:auto 1fr;gap:2px 10px;align-items:center}
.ffh-home .ffh-tile .ffh-ic{grid-row:span 2;width:30px;height:30px;border-radius:50%;display:grid;place-items:center}
.ffh-home .ffh-tile b{font-size:.82rem;color:var(--ink)}
.ffh-home .ffh-tile span{font-size:.72rem;color:var(--muted)}
.ffh-home .ffh-tile svg.ffh-spark{grid-column:1 / -1;width:100%;height:28px;margin-top:4px}
.ffh-home .ffh-care{position:relative;margin:-26px 0 0 auto;width:max-content;background:#fff;border:1px solid var(--line);border-radius:14px;padding:10px 12px;box-shadow:0 14px 30px -12px rgba(11,46,82,.3);display:flex;gap:10px;align-items:center;max-width:210px}
.ffh-home .ffh-care .ffh-av{width:34px;height:34px;border-radius:50%;background:var(--sky-2);display:grid;place-items:center;color:var(--blue-ink);font-weight:800;font-size:.8rem;flex:0 0 auto}
.ffh-home .ffh-care b{display:block;font-size:.78rem}
.ffh-home .ffh-care span{font-size:.7rem;color:var(--muted)}
@media (max-width:520px){.ffh-home .ffh-care{margin:12px auto 0}}

/* entity strip */
.ffh-home .ffh-entity{border-left:4px solid var(--blue);padding:4px 0 4px 18px;color:var(--muted);font-size:var(--fs-sm);max-width:90ch}

/* stats */
.ffh-home .ffh-stats{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:0;border-top:1px solid var(--line);border-bottom:1px solid var(--line)}
.ffh-home .ffh-stat{padding:28px 24px;display:grid;gap:6px;align-content:start}
.ffh-home .ffh-stat + .ffh-stat{border-left:1px solid var(--line)}
.ffh-home .ffh-stat .ffh-num{font-size:clamp(2.2rem,1.6rem + 2vw,3.2rem);font-weight:800;color:var(--blue-deep);letter-spacing:-.02em;line-height:1;font-variant-numeric:tabular-nums}
.ffh-home .ffh-stat p{font-size:var(--fs-sm)}
.ffh-home .ffh-stat cite{font-style:normal;font-size:var(--fs-xs);color:var(--muted)}
.ffh-home .ffh-stat cite a{color:var(--muted)}
@media (max-width:760px){.ffh-home .ffh-stats{grid-template-columns:1fr}.ffh-home .ffh-stat + .ffh-stat{border-left:0;border-top:1px solid var(--line)}}

/* audience */
.ffh-home .ffh-aud{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:16px}
.ffh-home .ffh-aud a{display:grid;gap:10px;align-content:start;padding:22px;border-radius:var(--r-md);border:1px solid var(--line);background:#fff;text-decoration:none;color:var(--ink);transition:border-color .15s,transform .15s}
.ffh-home .ffh-aud a:hover{border-color:var(--blue);transform:translateY(-2px)}
.ffh-home .ffh-aud .ffh-ico{width:48px;height:48px;border-radius:50%;display:grid;place-items:center}
.ffh-home .ffh-aud .ffh-ico svg{width:24px;height:24px}
.ffh-home .ffh-aud h3{font-size:1.08rem}
.ffh-home .ffh-aud p{font-size:var(--fs-sm);color:var(--muted)}
.ffh-home .ffh-aud .ffh-go{font-weight:700;color:var(--blue);font-size:var(--fs-sm)}
@media (max-width:980px){.ffh-home .ffh-aud{grid-template-columns:repeat(2,minmax(0,1fr))}}
@media (max-width:520px){.ffh-home .ffh-aud{grid-template-columns:1fr}}

/* steps */
.ffh-home .ffh-steps{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:24px;counter-reset:s;list-style:none;padding:0;margin:0}
.ffh-home .ffh-steps li{display:grid;gap:8px;align-content:start;position:relative;padding-top:56px}
.ffh-home .ffh-steps li::before{counter-increment:s;content:counter(s);position:absolute;top:0;left:0;width:40px;height:40px;border-radius:50%;background:var(--orange);color:#fff;font-weight:800;display:grid;place-items:center}
.ffh-home .ffh-steps li::after{content:"";position:absolute;top:20px;left:52px;right:-12px;height:2px;background:repeating-linear-gradient(90deg,var(--sky-2) 0 6px,transparent 6px 12px)}
.ffh-home .ffh-steps li:last-child::after{display:none}
.ffh-home .ffh-steps p{font-size:var(--fs-sm);color:var(--muted)}
@media (max-width:860px){.ffh-home .ffh-steps{grid-template-columns:1fr 1fr}.ffh-home .ffh-steps li::after{display:none}}
@media (max-width:520px){.ffh-home .ffh-steps{grid-template-columns:1fr}}

/* status tiers */
.ffh-home .ffh-tiers{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:14px}
.ffh-home .ffh-tier{border-radius:var(--r-md);padding:18px;display:grid;gap:8px;align-content:start;background:#fff;border:1px solid var(--line);border-top:6px solid var(--c)}
.ffh-home .ffh-tier b{display:flex;gap:8px;align-items:center;font-size:1.05rem}
.ffh-home .ffh-tier b i{width:12px;height:12px;border-radius:50%;background:var(--c)}
.ffh-home .ffh-tier p{font-size:var(--fs-sm);color:var(--muted)}
.ffh-home .ffh-tier .ffh-who{font-size:var(--fs-xs);font-weight:700;color:var(--ink)}
@media (max-width:860px){.ffh-home .ffh-tiers{grid-template-columns:1fr 1fr}}
@media (max-width:460px){.ffh-home .ffh-tiers{grid-template-columns:1fr}}

/* journey (flyer bands) */
.ffh-home .ffh-journey{display:grid;gap:12px}
.ffh-home .ffh-stage{display:grid;grid-template-columns:72px minmax(0,1fr) minmax(0,1.2fr);gap:20px;align-items:center;background:var(--bg);border-radius:999px;padding:12px 28px 12px 12px}
.ffh-home .ffh-stage .ffh-ico{width:64px;height:64px;border-radius:50%;background:var(--c);display:grid;place-items:center;color:#fff}
.ffh-home .ffh-stage .ffh-ico svg{width:30px;height:30px}
.ffh-home .ffh-stage h3{color:var(--c);font-size:1.3rem}
.ffh-home .ffh-stage small{display:block;color:var(--muted);font-size:var(--fs-sm)}
.ffh-home .ffh-stage ul{margin:0;padding-left:18px;font-size:var(--fs-sm)}
@media (max-width:760px){.ffh-home .ffh-stage{grid-template-columns:56px minmax(0,1fr);border-radius:var(--r-lg);padding:14px}.ffh-home .ffh-stage .ffh-ico{width:52px;height:52px}.ffh-home .ffh-stage ul{grid-column:1 / -1}}

/* compare */
.ffh-home .ffh-tbl-wrap{overflow-x:auto;border:1px solid var(--line);border-radius:var(--r-md);background:#fff}
.ffh-home table{border-collapse:collapse;width:100%;min-width:560px;font-size:var(--fs-sm)}
.ffh-home th,.ffh-home td{padding:14px 18px;text-align:left;border-bottom:1px solid var(--line);vertical-align:top}
.ffh-home thead th{background:var(--wash);font-size:var(--fs-xs);text-transform:uppercase;letter-spacing:.08em;color:var(--muted)}
.ffh-home tbody th{font-weight:700;color:var(--ink)}
.ffh-home td.ffh-us{background:#F3F8FD;font-weight:600;color:var(--blue-ink)}
.ffh-home tr:last-child th,.ffh-home tr:last-child td{border-bottom:0}

/* two-col generic */
.ffh-home .ffh-split{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:clamp(24px,4vw,56px);align-items:start}
@media (max-width:860px){.ffh-home .ffh-split{grid-template-columns:1fr}}
.ffh-home .ffh-checks{list-style:none;padding:0;margin:0;display:grid;gap:12px}
.ffh-home .ffh-checks li{display:grid;grid-template-columns:24px minmax(0,1fr);gap:10px;font-size:var(--fs-sm)}
.ffh-home .ffh-checks li::before{content:"";width:22px;height:22px;border-radius:50%;background:var(--sky) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%231F6FB2' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 12l5 5L20 7'/%3E%3C/svg%3E") center/14px no-repeat;margin-top:1px}

/* devices */
.ffh-home .ffh-devices{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px}
.ffh-home .ffh-dev{border:1px solid var(--line);border-radius:var(--r-md);padding:20px;background:#fff;display:grid;gap:8px;align-content:start}
.ffh-home .ffh-dev .ffh-tag{justify-self:start;font-size:.7rem;font-weight:800;letter-spacing:.08em;text-transform:uppercase;padding:3px 8px;border-radius:999px;background:var(--sky);color:var(--blue-ink)}
.ffh-home .ffh-dev .ffh-tag.ffh-req{background:#FFF3E6;color:var(--orange-ink)}
.ffh-home .ffh-dev p{font-size:var(--fs-sm);color:var(--muted)}
@media (max-width:860px){.ffh-home .ffh-devices{grid-template-columns:1fr}}
.ffh-home details.ffh-disclosure{margin-top:18px;border:1px solid var(--line);border-radius:var(--r-md);background:#fff}
.ffh-home details.ffh-disclosure summary{cursor:pointer;padding:14px 18px;font-weight:700;font-size:var(--fs-sm);color:var(--blue-ink)}
.ffh-home details.ffh-disclosure dl{margin:0;padding:0 18px 18px;display:grid;gap:12px}
.ffh-home details.ffh-disclosure dt{font-weight:700;font-size:var(--fs-sm)}
.ffh-home details.ffh-disclosure dd{margin:2px 0 0;font-size:var(--fs-sm);color:var(--muted)}

/* people */
.ffh-home .ffh-people{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:20px}
.ffh-home .ffh-person{display:grid;grid-template-columns:64px minmax(0,1fr);gap:14px;align-items:start}
.ffh-home .ffh-person .ffh-ph{width:64px;height:64px;border-radius:50%;background:linear-gradient(135deg,var(--sky-2),#fff);border:2px solid #fff;box-shadow:0 0 0 1px var(--line);display:grid;place-items:center;font-weight:800;color:var(--blue-ink)}
.ffh-home .ffh-person b{display:block;color:var(--blue-deep)}
.ffh-home .ffh-band.ffh-deep .ffh-person b{color:#fff}
.ffh-home .ffh-band.ffh-deep .ffh-person span{color:#B9CCE0}
.ffh-home .ffh-person span{font-size:var(--fs-sm);color:var(--muted)}
@media (max-width:860px){.ffh-home .ffh-people{grid-template-columns:1fr}}
.ffh-home .ffh-creds{display:flex;flex-wrap:wrap;gap:10px;margin-top:24px}
.ffh-home .ffh-creds span{border:1px solid var(--line);border-radius:999px;padding:6px 14px;font-size:var(--fs-xs);font-weight:700;color:var(--blue-ink);background:#fff}

/* pricing */
.ffh-home .ffh-plans{display:grid;grid-template-columns:minmax(0,1.1fr) minmax(0,1fr) minmax(0,1fr);gap:16px;align-items:stretch}
.ffh-home .ffh-plan{border:1px solid var(--line);border-radius:var(--r-lg);padding:26px;display:grid;gap:14px;align-content:start;background:#fff}
.ffh-home .ffh-plan.ffh-hot{border:2px solid var(--orange);background:linear-gradient(180deg,#FFF8F0,#fff 40%);box-shadow:0 24px 40px -24px rgba(232,132,44,.5)}
.ffh-home .ffh-plan .ffh-tag{justify-self:start;font-size:.7rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;padding:4px 10px;border-radius:999px;background:var(--orange);color:#fff}
.ffh-home .ffh-plan .ffh-price{font-size:2.4rem;font-weight:800;color:var(--blue-deep);line-height:1;font-variant-numeric:tabular-nums}
.ffh-home .ffh-plan .ffh-price small{display:block;margin-top:6px;font-size:.95rem;color:var(--muted);font-weight:600}
.ffh-home .ffh-plan ul{margin:0;padding:0;list-style:none;display:grid;gap:8px;font-size:var(--fs-sm)}
.ffh-home .ffh-plan li::before{content:"✓";color:var(--green);font-weight:800;margin-right:8px}
@media (max-width:900px){.ffh-home .ffh-plans{grid-template-columns:1fr}}

/* faq */
.ffh-home .ffh-faq{display:grid;gap:10px;max-width:860px}
.ffh-home .ffh-faq details{border:1px solid var(--line);border-radius:var(--r-md);background:#fff}
.ffh-home .ffh-faq summary{cursor:pointer;list-style:none;padding:18px 52px 18px 20px;font-weight:700;color:var(--blue-deep);position:relative}
.ffh-home .ffh-faq summary::-webkit-details-marker{display:none}
.ffh-home .ffh-faq summary::after{content:"+";position:absolute;right:20px;top:14px;font-size:1.5rem;color:var(--orange);font-weight:400}
.ffh-home .ffh-faq details[open] summary::after{content:"–"}
.ffh-home .ffh-faq .ffh-ans{padding:0 20px 18px;color:var(--muted);font-size:var(--fs-sm);max-width:72ch}

/* final cta */
.ffh-home .ffh-final.ffh-alt{background:var(--sky);color:var(--ink)}
.ffh-home .ffh-final.ffh-alt h2{color:var(--blue-deep)}
.ffh-home .ffh-final.ffh-alt p{color:var(--muted)}
.ffh-home .ffh-final{background:linear-gradient(135deg,var(--blue) 0%,var(--blue-deep) 100%);color:#fff;border-radius:var(--r-lg);padding:clamp(28px,5vw,56px);display:grid;grid-template-columns:minmax(0,1.4fr) minmax(0,1fr);gap:24px;align-items:center}
.ffh-home .ffh-final h2{color:#fff}
.ffh-home .ffh-final p{color:#D5E5F4}
@media (max-width:860px){.ffh-home .ffh-final{grid-template-columns:1fr}}

/* footer */
.ffh-home .ffh-site-foot{background:var(--blue-deep);color:#B9CCE0;padding-block:56px 110px;font-size:var(--fs-sm)}
.ffh-home .ffh-foot-grid{display:grid;grid-template-columns:minmax(0,1.4fr) repeat(3,minmax(0,1fr));gap:28px}
.ffh-home .ffh-site-foot h4{color:#fff;font-size:var(--fs-xs);letter-spacing:.12em;text-transform:uppercase;margin:0 0 10px}
.ffh-home .ffh-site-foot ul{list-style:none;margin:0;padding:0;display:grid;gap:6px}
.ffh-home .ffh-site-foot a{color:#DCE8F4;text-decoration:none}
.ffh-home .ffh-site-foot a:hover{text-decoration:underline}
.ffh-home .ffh-legal{margin-top:36px;padding-top:20px;border-top:1px solid rgba(255,255,255,.14);display:grid;gap:8px;font-size:var(--fs-xs);color:#9DB3CB}
.ffh-home .ffh-site-foot .ffh-brand b,.ffh-home .ffh-site-foot .ffh-brand b span{color:#fff}
.ffh-home .ffh-site-foot .ffh-brand small{color:#9DB3CB}
@media (max-width:860px){.ffh-home .ffh-foot-grid{grid-template-columns:1fr 1fr}}

/* sticky mobile cta */
.ffh-home .ffh-mbar{display:none}
@media (max-width:760px){.ffh-home .ffh-mbar{display:flex;position:fixed;left:0;right:0;bottom:0;z-index:20;gap:8px;background:rgba(255,255,255,.97);border-top:1px solid var(--line);padding:10px max(12px,env(safe-area-inset-right,0px)) calc(10px + env(safe-area-inset-bottom,0px)) max(12px,env(safe-area-inset-left,0px))}.ffh-home .ffh-mbar .ffh-btn{flex:1;min-height:44px;padding:0 10px}}

/* inner page */
.ffh-home .ffh-crumbs{font-size:var(--fs-xs);color:var(--muted);display:flex;gap:6px;flex-wrap:wrap}
.ffh-home .ffh-crumbs a{color:var(--muted)}
.ffh-home .ffh-page-hero{background:linear-gradient(180deg,var(--sky) 0%,#fff 100%);padding-block:24px 40px}
.ffh-home .ffh-page-hero .ffh-wrap{display:grid;gap:20px}
.ffh-home .ffh-answer{font-size:clamp(1.0625rem,1rem + .4vw,1.25rem);color:var(--ink);max-width:68ch;border-left:4px solid var(--orange);padding-left:18px}
.ffh-home .ffh-byline{display:flex;flex-wrap:wrap;gap:6px 18px;font-size:var(--fs-xs);color:var(--muted)}
.ffh-home .ffh-byline b{color:var(--ink)}
.ffh-home .ffh-layout{display:grid;grid-template-columns:minmax(0,1fr) 300px;gap:48px;align-items:start}
.ffh-home .ffh-layout > *{min-width:0}
.ffh-home .ffh-aside{position:sticky;top:calc(env(safe-area-inset-top,0px) + 88px);display:grid;gap:16px}
@media (max-width:980px){.ffh-home .ffh-layout{grid-template-columns:1fr}.ffh-home .ffh-aside{position:static}}
.ffh-home .ffh-toc{border:1px solid var(--line);border-radius:var(--r-md);padding:16px 18px;background:#fff}
.ffh-home .ffh-toc b{font-size:var(--fs-xs);letter-spacing:.1em;text-transform:uppercase;color:var(--muted)}
.ffh-home .ffh-toc ol{margin:8px 0 0;padding-left:20px;font-size:var(--fs-sm);display:grid;gap:6px}
.ffh-home .ffh-aside .ffh-cta-card{background:var(--blue-deep);color:#D5E5F4;border-radius:var(--r-md);padding:20px;display:grid;gap:12px}
.ffh-home .ffh-aside .ffh-cta-card b{color:#fff;font-size:1.05rem}
.ffh-home .ffh-prose{display:grid;gap:40px}
.ffh-home .ffh-prose section{display:grid;gap:14px}
.ffh-home .ffh-prose p,.ffh-home .ffh-prose li{max-width:70ch}
.ffh-home .ffh-prose ul{margin:0;padding-left:20px;display:grid;gap:6px}
.ffh-home .ffh-keystats{border:1px solid var(--sky-2);border-radius:var(--r-md);background:var(--wash);padding:20px;display:grid;gap:12px}
.ffh-home .ffh-keystats h2{font-size:1.1rem}
.ffh-home .ffh-keystats ul{list-style:none;margin:0;padding:0;display:grid;gap:12px}
.ffh-home .ffh-keystats li{font-size:var(--fs-sm)}
.ffh-home .ffh-keystats cite{display:block;font-style:normal;font-size:var(--fs-xs);color:var(--muted)}
.ffh-home .ffh-photo{margin:0;border-radius:var(--r-lg);overflow:hidden;background:linear-gradient(135deg,var(--sky-2),var(--preg-bg) 60%,var(--post-bg));aspect-ratio:16/8;max-width:100%;display:grid;place-items:end start}
.ffh-home .ffh-photo figcaption{background:rgba(255,255,255,.92);margin:14px;padding:10px 12px;border-radius:10px;font-size:var(--fs-xs);color:var(--muted);max-width:60ch}
.ffh-home .ffh-photo figcaption b{color:var(--blue-ink)}
.ffh-home .ffh-authorbox{display:grid;grid-template-columns:72px minmax(0,1fr);gap:16px;border:1px solid var(--line);border-radius:var(--r-md);padding:20px;background:#fff}
.ffh-home .ffh-authorbox .ffh-ph{width:72px;height:72px;border-radius:50%;background:var(--sky-2);display:grid;place-items:center;font-weight:800;color:var(--blue-ink)}
.ffh-home .ffh-authorbox p{font-size:var(--fs-sm);color:var(--muted)}
.ffh-home .ffh-related{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:10px}
.ffh-home .ffh-related a{display:block;padding:12px 14px;border:1px solid var(--line);border-radius:var(--r-sm);text-decoration:none;font-size:var(--fs-sm);font-weight:600;background:#fff}
.ffh-home .ffh-related a:hover{border-color:var(--blue)}
.ffh-home .ffh-inline-cta{display:flex;flex-wrap:wrap;gap:12px;align-items:center;background:#FFF8F0;border:1px solid #F6CFA5;border-radius:var(--r-md);padding:16px 18px}
.ffh-home .ffh-inline-cta p{flex:1 1 260px;font-size:var(--fs-sm);font-weight:600;color:var(--orange-ink)}
.ffh-home .ffh-notice{font-size:var(--fs-xs);color:var(--muted);border-top:1px solid var(--line);padding-top:16px}
@media (max-width:560px){.ffh-home .ffh-btn{white-space:normal;text-align:center;line-height:1.2;padding-block:8px}.ffh-home .ffh-mbar .ffh-btn{font-size:.8125rem;padding-inline:8px}.ffh-home .ffh-cta-row .ffh-btn{flex:1 1 100%}}`;

export default function HomePage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd }} />
      <Header />
      <main className="ffh-home">
        <section className="ffh-hero">
          <div className="ffh-wrap">
            <div className="topvideo_section">
              <div className=" row">
                <div className=" col-md-6">
                  <span className="ffh-eyebrow">Physician-connected pregnancy wellness</span>
                  <h1>
                    Pregnancy monitoring
                  </h1>
                  <p style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--blue-ink)" }}>
                    Pregnancy happens every day. Now your care team can see the days between visits.
                  </p>
                  <p className="ffh-lead speakable-content">
                    FutureFamilyAI is a pregnancy monitoring app that brings your validated-cuff blood pressure readings,
                    smartwatch heart-rate, sleep and activity trends, and symptom notes into one calm color status.
                    Prenatal visits are often four weeks apart early in pregnancy.
                  </p>

                </div>
                <div className="col-md-6" aria-label="Example FutureFamilyAI app screen (illustrative)">
                  <iframe
                    width="100%"
                    height="395"
                    src="https://www.youtube.com/embed/qkcJIlDqYqI"
                    title="FutureFamilyAI | Physician-Connected Pregnancy Monitoring Between Visits"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                FutureFamilyAI turns validated-cuff blood pressure readings, smartwatch trends and symptoms into one
                color status your care team can review between prenatal visits.
              </p>
              <details>
                <summary>More fast facts: audience, key stat, safety, cost</summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>
                      Expecting and planning mothers, gestational surrogates, OB physicians, IVF clinics and surrogacy
                      agencies.
                    </dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Hypertensive disorders were present in about 1 in 7 U.S. delivery hospitalizations (2017–2019).
                      (CDC, MMWR 2022)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red statuses reviewed by a real care team. Not for
                      emergencies — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Validated cuff + smartwatch in one view · Care-team review at Orange/Red — never an algorithm
                      alone · Free pilot through Dec 31, 2026
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>Free pilot through Dec 31, 2026; then $39.99/mo or $399/yr. Devices separate.</dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>Download on the App Store, or request free pilot access at futurefamilyai.com/contact-us/</dd>
                  </div>
                </dl>
              </details>
            </aside>
            <div className="ffh-hero-grid">
              <div className="ffh-hero-copy">
                <span className="ffh-eyebrow">Physician-connected pregnancy wellness</span>
                <h1>
                  Pregnancy monitoring <em>between visits, connected to your doctor</em>
                </h1>
                <p style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--blue-ink)" }}>
                  Pregnancy happens every day. Now your care team can see the days between visits.
                </p>
                <p className="ffh-lead speakable-content">
                  FutureFamilyAI is a pregnancy monitoring app that brings your validated-cuff blood pressure readings,
                  smartwatch heart-rate, sleep and activity trends, and symptom notes into one calm color status.
                  Prenatal visits are often four weeks apart early in pregnancy; your health changes every day. When a
                  pattern is worth a closer look, a real care team reviews it — guided by an ACOG/SMFM-based protocol.
                  Join the free pilot to start.
                </p>
                <span className="ffh-pilot-badge">
                  <i></i>Free pilot enrollment open through December 31, 2026
                </span>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href="/contact-us">
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                    Request Free Pilot Access
                  </Link>
                </div>
                <p className="ffh-safety">
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" />
                    <path d="M9 12l2 2 4-4" />
                  </svg>
                  <span>
                    A wellness tool that supports, and never replaces, your prenatal care. Not monitored in real time.
                    In an emergency, call 911.
                  </span>
                </p>
              </div>
              <div className="ffh-device" aria-label="Example FutureFamilyAI app screen (illustrative)">
                <div className="ffh-phone">
                  <div className="ffh-screen">
                    <div className="ffh-top">
                      <span>Today · Week 29</span>
                      <span>Synced 7:42 AM</span>
                    </div>
                    <h4>Good morning, Maya</h4>
                    <div className="ffh-status">
                      <span className="ffh-pill">
                        <i></i>Steady
                      </span>
                      <p>Your morning cuff reading and symptoms are consistent with your baseline. Keep going.</p>
                    </div>
                    <div className="ffh-tile">
                      <span className="ffh-ic" style={{ background: "#FDECEC", color: "#D64545" }}>
                        <svg
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z" />
                        </svg>
                      </span>
                      <b>Heart rate & PRV</b>
                      <span>Within your usual range</span>
                      <svg className="ffh-spark" viewBox="0 0 200 28" preserveAspectRatio="none">
                        <polyline
                          points="0,18 20,15 40,17 60,12 80,14 100,10 120,13 140,11 160,14 180,12 200,13"
                          fill="none"
                          stroke="#D64545"
                          strokeWidth="2.2"
                          strokeLinejoin="round"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div className="ffh-tile">
                      <span className="ffh-ic" style={{ background: "#F2ECFC", color: "#7A4FCF" }}>
                        <svg
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <rect x="4" y="5" width="16" height="15" rx="2" />
                          <path d="M8 3v4M16 3v4M4 10h16" />
                        </svg>
                      </span>
                      <b>Sleep</b>
                      <span>7h 24m · steady this week</span>
                    </div>
                    <div className="ffh-tile">
                      <span className="ffh-ic" style={{ background: "#EAF3FB", color: "#1F6FB2" }}>
                        <svg
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <path d="M3 12h4l2-5 4 10 2-5h6" />
                        </svg>
                      </span>
                      <b>Cuff reading logged</b>
                      <span>Validated upper-arm cuff · 7:40 AM</span>
                    </div>
                  </div>
                </div>
                <div className="ffh-care">
                  <span className="ffh-av">CT</span>
                  <span>
                    <b>Care team connected</b>
                    <span>Reviews Orange & Red statuses</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "28px 0" }}>
          <div className="ffh-wrap">
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and family-planning wellness app that turns home blood
              pressure readings from a validated cuff, smartwatch wellness trends and symptom notes into a simple color
              status your care team can review between visits. Its monitoring protocol was developed by Dr. Kulsoom
              Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA guidance, and every page is medically reviewed by Dr.
              Rashmi Gulati, MD, Medical Director of Patients Medical (Manhattan, since 1974). FutureFamilyAI is a
              product of HelixFoundry, Inc., and is used by Surrogacy4All to support its gestational surrogates.
            </p>
          </div>
        </section>
        <section className="ffh-band">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">Why the in-between matters</span>
              <h2>The biggest changes often happen between appointments</h2>
              <p className="ffh-lead">
                High blood pressure in pregnancy often has no symptoms. A two-minute daily check gives your clinician
                far more than a few minutes in an exam room.
              </p>
            </div>
            <div className="ffh-stats">
              <div className="ffh-stat">
                <span className="ffh-num">1 in 7</span>
                <p>U.S. delivery hospitalizations involved a hypertensive disorder of pregnancy.</p>
                <cite>
                  Source: <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">CDC, MMWR 2022</a>
                </cite>
              </div>
              <div className="ffh-stat">
                <span className="ffh-num">~4 weeks</span>
                <p>Typical gap between routine prenatal visits until about 28 weeks.</p>
                <cite>
                  Source: <a href="https://www.acog.org/womens-health/faqs/having-a-baby">ACOG</a>
                </cite>
              </div>
              <div className="ffh-stat">
                <span className="ffh-num">1 in 3</span>
                <p>Pregnancy-related deaths happened between 1 week and 1 year after delivery.</p>
                <cite>
                  Source: <a href="https://www.cdc.gov/vitalsigns/maternal-deaths/">CDC Vital Signs, 2019</a>
                </cite>
              </div>
            </div>
          </div>
        </section>
        <section className="ffh-band ffh-wash">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">Who are you here for?</span>
              <h2>Built for the four people in every pregnancy journey</h2>
            </div>
            <div className="ffh-aud">
              <Link to="/pregnancy-monitoring">
                <span className="ffh-ico" style={{ background: "#EAF3FB", color: "#1F6FB2" }}>
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <circle cx="11" cy="5" r="2.2" />
                    <path d="M9 9h3a5 5 0 0 1 3 9h-3l-1 3M9 9l-1 6 2 1" />
                  </svg>
                </span>
                <h3>Expecting &amp; planning mothers</h3>
                <p>Daily peace of mind and a clear plan when something changes.</p>
                <span className="ffh-go">Explore monitoring →</span>
              </Link>
              <Link to="/surrogacy/wellness-monitoring">
                <span className="ffh-ico" style={{ background: "#FCEBF2", color: "#D2477E" }}>
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" />
                    <path d="M9 12l2 2 4-4" />
                  </svg>
                </span>
                <h3>Gestational surrogates</h3>
                <p>Support that respects you. You control who sees your data.</p>
                <span className="ffh-go">Surrogate support →</span>
              </Link>
              <Link to="/providers">
                <span className="ffh-ico" style={{ background: "#E9F6EE", color: "#2E9E4F" }}>
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M6 3v6a4 4 0 0 0 8 0V3" />
                    <path d="M10 13v2a5 5 0 0 0 10 0v-2" />
                    <circle cx="20" cy="11" r="2" />
                  </svg>
                </span>
                <h3>Physicians &amp; OB teams</h3>
                <p>Organized, source-labeled trends with human review at Orange and Red.</p>
                <span className="ffh-go">For physicians →</span>
              </Link>
              <Link to="/partners">
                <span className="ffh-ico" style={{ background: "#F2ECFC", color: "#7A4FCF" }}>
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M4 21V8l8-5 8 5v13" />
                    <path d="M12 10v6M9 13h6" />
                  </svg>
                </span>
                <h3>IVF clinics &amp; agencies</h3>
                <p>Extend support beyond the appointment. No partner fees.</p>
                <span className="ffh-go">Partner with us →</span>
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" id="how">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">How it works</span>
              <h2>Set up in minutes. Two minutes a day after that.</h2>
            </div>
            <ol className="ffh-steps">
              <li>
                <h3>Choose your path</h3>
                <p>
                  Tell us whether you are planning, pregnant, a surrogate or postpartum. Your dashboard and reminders
                  adapt to that stage.
                </p>
              </li>
              <li>
                <h3>Connect your devices</h3>
                <p>
                  Pair your phone with a validated upper-arm cuff and an Apple Watch or Samsung Galaxy Watch. A 7–14 day
                  baseline helps personalize your trends.
                </p>
              </li>
              <li>
                <h3>Two minutes a day</h3>
                <p>
                  Take your cuff reading as your clinician instructs and log symptoms. Your status updates in plain
                  language.
                </p>
              </li>
              <li>
                <h3>Your care team stays in the loop</h3>
                <p>
                  Orange and Red patterns are reviewed by people, not just software. You decide exactly who else can see
                  your information.
                </p>
              </li>
            </ol>
            <div className="ffh-cta-row" style={{ marginTop: "32px" }}>
              <a className="ffh-btn ffh-primary" href="contact-us">
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band ffh-sky">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">Wellness you can see</span>
              <h2>One calm status. Never a number to decode.</h2>
              <p className="ffh-lead">
                Members see a color and one sentence of guidance, never a numeric risk score. Orange and Red are always
                reviewed by people, not by an algorithm alone.
              </p>
            </div>
            <div className="ffh-tiers">
              <div className="ffh-tier" style={{ "--c": "#2E9E4F" }}>
                <b>
                  <i></i>Green · Steady
                </b>
                <p>Readings look consistent with your baseline. Keep going.</p>
                <span className="ffh-who">You</span>
              </div>
              <div className="ffh-tier" style={{ "--c": "#E8B923" }}>
                <b>
                  <i></i>Yellow · Worth a look
                </b>
                <p>A trend to watch, with simple guidance on what to do next.</p>
                <span className="ffh-who">You, with guidance</span>
              </div>
              <div className="ffh-tier" style={{ "--c": "#E8842C" }}>
                <b>
                  <i></i>Orange · Reviewing
                </b>
                <p>Your care team is taking a closer look and may contact you.</p>
                <span className="ffh-who">Care team reviews</span>
              </div>
              <div className="ffh-tier" style={{ "--c": "#D64545" }}>
                <b>
                  <i></i>Red · Reach out
                </b>
                <p>Contact your provider now. For severe symptoms, call 911.</p>
                <span className="ffh-who">Care team reviews</span>
              </div>
            </div>
          </div>
        </section>
        <section className="ffh-band">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">The FutureFamilyAI program</span>
              <h2>One connected health history, from planning to decades after</h2>
            </div>
            <div className="ffh-journey">
              <div className="ffh-stage" style={{ "--c": "var(--plan)", "--bg": "var(--plan-bg)" }}>
                <span className="ffh-ico">
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <rect x="4" y="5" width="16" height="15" rx="2" />
                    <path d="M8 3v4M16 3v4M4 10h16" />
                  </svg>
                </span>
                <div>
                  <h3>
                    <Link to="/family-planning--carrier-screening" style={{ color: "inherit", textDecoration: "none" }}>
                      Planning
                    </Link>
                  </h3>
                  <small>Baseline &amp; carrier screening</small>
                </div>
                <ul>
                  <li>Build a personal blood pressure and wellness baseline</li>
                  <li>Optional at-home carrier screening for couples</li>
                </ul>
              </div>
              <div className="ffh-stage" style={{ "--c": "var(--preg)", "--bg": "var(--preg-bg)" }}>
                <span className="ffh-ico">
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <circle cx="11" cy="5" r="2.2" />
                    <path d="M9 9h3a5 5 0 0 1 3 9h-3l-1 3M9 9l-1 6 2 1" />
                  </svg>
                </span>
                <div>
                  <h3>
                    <Link
                      to="/monitoring--blood-pressure-pregnancy"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Pregnancy
                    </Link>
                  </h3>
                  <small>Guided monitoring</small>
                </div>
                <ul>
                  <li>Track cuff readings, heart rate, sleep and symptoms</li>
                  <li>Care-team review when a pattern needs attention</li>
                </ul>
              </div>
              <div className="ffh-stage" style={{ "--c": "var(--post)", "--bg": "var(--post-bg)" }}>
                <span className="ffh-ico">
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="9" r="4" />
                    <path d="M5 21c1-4 4-6 7-6s6 2 7 6" />
                  </svg>
                </span>
                <div>
                  <h3>
                    <Link to="/postpartum--long-term-health" style={{ color: "inherit", textDecoration: "none" }}>
                      Postpartum
                    </Link>
                  </h3>
                  <small>The high-risk window</small>
                </div>
                <ul>
                  <li>Monitoring continues after delivery</li>
                  <li>Reminders that fit life with a newborn</li>
                </ul>
              </div>
              <div className="ffh-stage" style={{ "--c": "var(--after)", "--bg": "var(--after-bg)" }}>
                <span className="ffh-ico">
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z" />
                  </svg>
                </span>
                <div>
                  <h3>
                    <Link
                      to="/postpartum-cardiovascular-risk-after-preeclampsia"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Years after
                    </Link>
                  </h3>
                  <small>Cardiovascular awareness</small>
                </div>
                <ul>
                  <li>Keep your pregnancy history in your health record</li>
                  <li>Ongoing heart-health tracking</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="ffh-band ffh-wash">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">Why it's different</span>
              <h2>More than a pregnancy tracker</h2>
            </div>
            <div className="ffh-tbl-wrap">
              <table>
                <thead>
                  <tr>
                    <th scope="col">What matters</th>
                    <th scope="col">Typical pregnancy app</th>
                    <th scope="col">FutureFamilyAI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Blood pressure</th>
                    <td>Manual note, if any</td>
                    <td className="ffh-us">Validated upper-arm cuff, synced and time-stamped</td>
                  </tr>
                  <tr>
                    <th scope="row">Clinical basis</th>
                    <td>General content</td>
                    <td className="ffh-us">Protocol informed by ACOG, SMFM, ISSHP and AHA guidance</td>
                  </tr>
                  <tr>
                    <th scope="row">When something changes</th>
                    <td>You search the internet</td>
                    <td className="ffh-us">Color status with guidance; people review Orange and Red</td>
                  </tr>
                  <tr>
                    <th scope="row">Care team</th>
                    <td>Not connected</td>
                    <td className="ffh-us">Physician-connected; share trends with your clinician</td>
                  </tr>
                  <tr>
                    <th scope="row">What you see</th>
                    <td>Charts and scores to interpret</td>
                    <td className="ffh-us">One calm color status, never a numeric risk score</td>
                  </tr>
                  <tr>
                    <th scope="row">After delivery</th>
                    <td>Usually stops</td>
                    <td className="ffh-us">Continues through postpartum and beyond</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section className="ffh-band">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">What you'll need</span>
              <h2>Works with devices you may already own</h2>
            </div>
            <div className="ffh-devices">
              <div className="ffh-dev">
                <span className="ffh-tag ffh-req">Required</span>
                <h3>Validated upper-arm cuff</h3>
                <p>Your only blood pressure source. Validated models typically cost $50–$85. Check ValidateBP.org.</p>
              </div>
              <div className="ffh-dev">
                <span className="ffh-tag ffh-req">Required</span>
                <h3>iPhone or Android phone</h3>
                <p>Runs the app and syncs your readings securely.</p>
              </div>
              <div className="ffh-dev">
                <span className="ffh-tag">Adds trends</span>
                <h3>Apple Watch or Samsung Galaxy Watch</h3>
                <p>
                  Apple Watch Series 9 or later (including Series 10 and 11), or Galaxy Watch4 or later. Adds
                  heart-rate, PRV, sleep and activity trends.
                </p>
              </div>
            </div>
            <details className="ffh-disclosure">
              <summary>Smartwatch & blood pressure disclosure</summary>
              <dl>
                <div>
                  <dt>Blood pressure source</dt>
                  <dd>
                    FutureFamilyAI uses readings from a validated upper-arm cuff as the only blood pressure values in
                    your record and status. Smartwatch data is shown as wellness trends only.
                  </dd>
                </div>
                <div>
                  <dt>Apple Watch (Series 9 and later, including Series 10 and 11)</dt>
                  <dd>
                    FutureFamilyAI uses the watch&apos;s optical sensor data for heart rate, pulse-rate variability
                    (PRV), sleep and activity trends. Apple Watch does not measure blood pressure. Apple&apos;s
                    Hypertension Notifications feature looks for patterns over 30-day periods; Apple states it is not
                    intended for people who are pregnant, under 22, or previously diagnosed with hypertension, and it
                    cannot be enabled while a pregnancy is logged in the Health app. FutureFamilyAI does not use or
                    display Apple&apos;s hypertension notifications.
                  </dd>
                </div>
                <div>
                  <dt>
                    Samsung Galaxy Watch (Watch4 and later, Wear OS 4+, with a Samsung Galaxy phone on Android 12+)
                  </dt>
                  <dd>
                    FutureFamilyAI uses the watch&apos;s sensor data for heart rate, PRV, sleep and activity trends.
                    Samsung&apos;s blood pressure feature estimates blood pressure after calibration with an upper-arm
                    cuff every 28 days and, per Samsung, is not intended to diagnose or prevent high blood pressure.
                    FutureFamilyAI does not use watch-estimated blood pressure values in your record, status or
                    care-team review.
                  </dd>
                </div>
                <div>
                  <dt>Not real-time</dt>
                  <dd>
                    Watch data syncs periodically through your phone. FutureFamilyAI is not monitored in real time and
                    is not an emergency service. In an emergency, call 911.
                  </dd>
                </div>
                <div>
                  <dt>Trademarks</dt>
                  <dd>
                    Apple Watch and iPhone are trademarks of Apple Inc. Samsung and Galaxy Watch are trademarks of
                    Samsung Electronics Co., Ltd. FutureFamilyAI is not affiliated with or endorsed by Apple or Samsung.
                  </dd>
                </div>
              </dl>
            </details>
          </div>
        </section>
        <section className="ffh-band ffh-deep">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">Who's behind it</span>
              <h2>Built and reviewed by physicians</h2>
              <p className="ffh-lead" style={{ color: "#C9D9EA" }}>
                Every clinical rule and every page on this site is written by a named clinician and medically reviewed
                before it goes live.
              </p>
            </div>
            <div className="ffh-people">
              <div className="ffh-person">
                <span className="ffh-ph">RG</span>
                <div>
                  <b>Dr. Rashmi Gulati, MD</b>
                  <span>Medical Director, Patients Medical · medically reviews all content</span>
                </div>
              </div>
              <div className="ffh-person">
                <span className="ffh-ph">KB</span>
                <div>
                  <b>Dr. Kulsoom Baloch, MBBS, MPH</b>
                  <span>Clinical protocol author</span>
                </div>
              </div>
              <div className="ffh-person">
                <span className="ffh-ph">PP</span>
                <div>
                  <b>Dr. Pooja Patel, MD</b>
                  <span>Surrogacy &amp; fertility content author</span>
                </div>
              </div>
            </div>
            <div className="ffh-creds">
              <span>Patients Medical · Manhattan · since 1974</span>
              <span>ACOG · SMFM · ISSHP · AHA-informed protocol</span>
              <span>Human review at Orange & Red</span>
              <span>Used by Surrogacy4All</span>
            </div>
          </div>
        </section>
        <section className="ffh-band">
          <div className="ffh-wrap ffh-split">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">Your data, your choice</span>
              <h2>Privacy that puts you in control</h2>
              <p className="ffh-lead">
                Whether you're carrying your own baby or someone else's, your health information belongs to you.
              </p>
              <Link className="ffh-btn ffh-ghost" to="/privacy-safety" style={{ justifySelf: "start" }}>
                Review data controls
              </Link>
            </div>
            <ul className="ffh-checks">
              <li>Nothing is shared by default</li>
              <li>Turn sharing on one person at a time: physician, partner, coordinator or intended parents</li>
              <li>Surrogates control what intended parents see</li>
              <li>Encrypted in transit and at rest</li>
              <li>Export or delete your data any time</li>
              <li>We never sell your health data</li>
            </ul>
          </div>
        </section>
        <section className="ffh-band ffh-wash" id="pricing">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">Simple pricing</span>
              <h2>Start free. Decide later.</h2>
            </div>
            <div className="ffh-plans">
              <div className="ffh-plan ffh-hot">
                <span className="ffh-tag">Free pilot · open now</span>
                <h3>Pilot access</h3>
                <div className="ffh-price">
                  $0 <small>subscription through Dec 31, 2026</small>
                </div>
                <ul>
                  <li>Blood pressure & wellness trends</li>
                  <li>Care-team review of Orange & Red</li>
                  <li>Postpartum monitoring</li>
                  <li>Sharing controls for every person</li>
                </ul>
                <Link className="ffh-btn ffh-primary" to="/contact-us?type=member">
                  Request Free Pilot Access
                </Link>
              </div>
              <div className="ffh-plan">
                <h3>Complete Monitoring</h3>
                <div className="ffh-price">
                  $39.99 <small>/ month after pilot</small>
                </div>
                <ul>
                  <li>Everything in the pilot</li>
                  <li>Cancel any time</li>
                </ul>
              </div>
              <div className="ffh-plan">
                <h3>Complete · Annual</h3>
                <div className="ffh-price">
                  $399 <small>/ year after pilot</small>
                </div>
                <ul>
                  <li>About two months free</li>
                  <li>Optional carrier-screening add-on</li>
                </ul>
              </div>
            </div>
            <p className="ffh-micro" style={{ marginTop: "14px" }}>
              Free pilot: no subscription fee for eligible participants through December 31, 2026. After the pilot,
              Complete Monitoring is $39.99/month or $399/year. Devices, lab tests and clinical visits are separate.
              We'll notify you before any subscription charge begins. Surrogates may receive FutureFamilyAI free through
              a participating agency.
            </p>
          </div>
        </section>
        <section className="ffh-band">
          <div className="ffh-wrap">
            <div className="ffh-final ffh-alt">
              <div className="ffh-stack">
                <span className="ffh-eyebrow">For IVF clinics & surrogacy agencies</span>
                <h2>Support patients beyond the appointment, with no fees</h2>
                <p>
                  Offer FutureFamilyAI to IVF patients and surrogates, get a free verified directory listing, and let
                  our care team handle setup questions.
                </p>
              </div>
              <div className="ffh-cta-row">
                <Link className="ffh-btn ffh-primary" to="/partners/join-referral-network">
                  Join the Partner Network — No Fees
                </Link>
                <Link className="ffh-btn ffh-ghost" to="/contact-us?type=physician">
                  Request a clinical demo
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="ffh-band ffh-wash">
          <div className="ffh-wrap">
            <div className="ffh-sec-head">
              <span className="ffh-eyebrow">Questions</span>
              <h2>Answers before you start</h2>
            </div>
            <div className="ffh-faq">
              <details open>
                <summary>Can a smartwatch measure blood pressure during pregnancy?</summary>
                <div className="ffh-ans speakable-content">
                  <p>
                    Not for FutureFamilyAI. Apple Watch does not measure blood pressure, and Apple&apos;s hypertension
                    notifications are not intended for use in pregnancy. Samsung Galaxy Watch estimates blood pressure
                    only after cuff calibration. FutureFamilyAI uses a validated upper-arm cuff as the only blood
                    pressure source; your watch adds heart-rate, PRV, sleep and activity trends.
                  </p>
                </div>
              </details>
              <details>
                <summary>Is FutureFamilyAI safe to use during pregnancy?</summary>
                <div className="ffh-ans speakable-content">
                  <p>
                    Yes. It is a non-invasive wellness app that reads data from your cuff and watch and asks simple
                    symptom questions. It does not give medical treatment, and it encourages you to follow your own
                    clinician&apos;s instructions.
                  </p>
                </div>
              </details>
              <details>
                <summary>Who reviews my alerts?</summary>
                <div className="ffh-ans speakable-content">
                  <p>
                    Orange and Red statuses are reviewed by a care team working with your clinician&apos;s instructions
                    — never by an algorithm alone. Reviews happen during care-team hours; the app is not monitored in
                    real time and is not an emergency service.
                  </p>
                </div>
              </details>
              <details>
                <summary>Can surrogates use FutureFamilyAI?</summary>
                <div className="ffh-ans">
                  <p>
                    Yes. Gestational surrogates can enroll directly or through a participating agency. The surrogate
                    controls sharing, and intended parents see only what she chooses to share.
                  </p>
                </div>
              </details>
              <details>
                <summary>Is my health information private?</summary>
                <div className="ffh-ans">
                  <p>
                    Nothing is shared by default. You turn on sharing one person at a time — your physician, partner,
                    coordinator or intended parents — and you can turn it off, export or delete your data whenever you
                    choose.
                  </p>
                </div>
              </details>
              <details>
                <summary>Who is behind FutureFamilyAI?</summary>
                <div className="ffh-ans">
                  <p>
                    FutureFamilyAI is a product of HelixFoundry, Inc., and is used by Surrogacy4All to support its
                    surrogates. Its clinical content is authored by Dr. Kulsoom Baloch, MBBS, MPH, and Dr. Pooja Patel,
                    MD, and reviewed by Dr. Rashmi Gulati, MD, of Patients Medical.
                  </p>
                </div>
              </details>
              <details>
                <summary>Does FutureFamilyAI replace my doctor or prenatal visits?</summary>
                <div className="ffh-ans">
                  <p>
                    No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own
                    clinician has more context between visits. Your care team makes every medical decision, and you
                    should keep all scheduled appointments.
                  </p>
                </div>
              </details>
              <details>
                <summary>How much does FutureFamilyAI cost?</summary>
                <div className="ffh-ans">
                  <p>
                    Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After
                    that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for
                    wearable trends) a smartwatch are purchased separately.
                  </p>
                </div>
              </details>
            </div>
            <div className="ffh-cta-row" style={{ marginTop: "28px" }}>
              <a className="ffh-btn ffh-primary" href="/contact-us">
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band">
          <div className="ffh-wrap">
            <div className="ffh-final">
              <div className="ffh-stack">
                <h2>See the days between your visits</h2>
                <p>
                  Join expecting mothers and surrogates in the FutureFamilyAI pilot. Free through December 31, 2026.
                </p>
              </div>
              <div className="ffh-cta-row">
                <a className="ffh-btn ffh-light" href="/contact-us">
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
                <Link
                  className="ffh-btn ffh-ghost"
                  style={{ color: "#fff", borderColor: "#9FC6EA" }}
                  to="/contact-us?type=member"
                >
                  Request free pilot access
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}